import checkout from "./form";

const {
  formField: {
    description,
    macAddress,
    location,
    timezone,
    project,
    status,
    deviceMacAddress,
    // profileImage,
    // collectIP,
    // signShift,
  },
} = checkout;

export default {
  [description.name]: "",
  [macAddress.name]: "",
  [deviceMacAddress.name]: "",
  [location.name]: "",
  [timezone.name]: "",
  [project.name]: "",
  [status.name]: true,
  // [profileImage.name]: false,
  // [collectIP.name]: false,
  // [signShift.name]: false,
};
